import { Component, Input, OnInit } from '@angular/core';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';

@Component({
    selector: 'app-deploy-detail-widget',
    templateUrl: './deploy-detail-widget.component.html',
    styleUrls: ['../base-widget/base-widget.component.scss', './deploy-detail-widget.component.scss'],
    standalone: false
})
export class DeployDetailWidgetComponent extends BaseWidgetComponent implements OnInit {
  @Input() serviceName: string;

  public title: string = 'Deployment';

  constructor() {
    super();
  }

  ngOnInit(): void {
    if (this.serviceName) {
      this.title = `Deployment: ${this.serviceName}`;
    }
  }
}
